import React, {FC, ReactNode} from 'react'

import cn from 'classnames/bind'

import s from './Card.module.scss'
const cx = cn.bind(s)

interface ICardProps {
	children: ReactNode
	className?: string
}

const Card: FC<ICardProps> = ({children, className}) => {
	return <div className={cx('card', className)}>{children}</div>
}

Card.displayName = 'Card'

export default Card
